import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  body{
    margin:0;
    background:#fff;
    color:#111;

    font-family: "Cormorant Garamond", Georgia, "Times New Roman", Times, serif;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    font-variant-numeric: lining-nums tabular-nums;
    font-feature-settings: "lnum" 1, "tnum" 1;

    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='103.923' viewBox='0 0 120 103.923'%3E%3Cg fill='none' stroke='%23c9a227' stroke-width='1.6' stroke-opacity='0.1' stroke-linejoin='round'%3E%3Cpath d='M30 2 L60 19.321 L60 53.962 L30 71.283 L0 53.962 L0 19.321 Z'/%3E%3Cpath d='M90 2 L120 19.321 L120 53.962 L90 71.283 L60 53.962 L60 19.321 Z'/%3E%3Cpath d='M60 54 L90 71.321 L90 105.962 L60 123.283 L30 105.962 L30 71.321 Z'/%3E%3C/g%3E%3C/svg%3E");
    background-size: 120px 103.923px;
    background-repeat: repeat;

    @media (max-width: 768px){
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='103.923' viewBox='0 0 120 103.923'%3E%3Cg fill='none' stroke='%23c9a227' stroke-width='1.6' stroke-opacity='0.2' stroke-linejoin='round'%3E%3Cpath d='M30 2 L60 19.321 L60 53.962 L30 71.283 L0 53.962 L0 19.321 Z'/%3E%3Cpath d='M90 2 L120 19.321 L120 53.962 L90 71.283 L60 53.962 L60 19.321 Z'/%3E%3Cpath d='M60 54 L90 71.321 L90 105.962 L60 123.283 L30 105.962 L30 71.321 Z'/%3E%3C/g%3E%3C/svg%3E");
      background-size: 88px 76.21px;
    }

    @media (max-width: 420px){
      background-size: 74px 64.08px;
    }
  }
`;
